export default {
  namespaced: true,
  state: {
    exportConfig: []
  },
  mutations: {
    addConfig: function (state, data) {
      state.exportConfig.push(data);
    },
    resetConfig: function (state) {
      state.exportConfig.splice(0, state.exportConfig.length);
    }
  },
  actions: {

  }
};
